<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
       <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Documents</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/document/index"
          >Manage Documents</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">{{ document.job_title || "View Document" }}</span>
      </h6>
     
      <div class="container-fluid">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <router-link
            v-if="document.id"
            :to="'/document/update?id=' + document.id"
            class="btn btn-sm btn-outline-primary mb-1 bdr-rad font-size_def"
            >Update</router-link
          >
        </div>
        <div v-if="isLoading" class="card custom_bdr_rds shadow p-2">
          <div class="card-body custom_bdr_rds">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary"></div>
            </div>
          </div>
        </div>
        <div v-else-if="document.id" class="mt-1">
          <div class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds">
              <table
                style="font-size: small"
                class="table table-hover table-sm table-borderless"
              >
                <tbody>
                  <tr>
                    <td class="width-custom2"><b>Document Title</b></td>
                    <td>{{ document.job_title }}</td>
                  </tr>
                  <tr>
                    <td><b>Document Type</b></td>
                    <td>{{ document.document_type || "-" }}</td>
                  </tr>
                  <tr>
                    <td><b>People</b></td>
                    <td>{{ document.employee || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card custom_bdr_rds shadow p-2 mt-3">
            <div class="card-body custom_bdr_rds">
              <div class="row">
                <div class="col-md-6">
                  <table style="font-size: small" class="table table-hover table-sm table-borderless">
                    <tbody>
                      <tr><td><b>Company</b></td><td>{{ document.company || "-" }}</td></tr>
                      <tr><td><b>Branch</b></td><td>{{ document.branch || "-" }}</td></tr>
                      <tr><td><b>Project</b></td><td>{{ document.project || "-" }}</td></tr>
                      <tr><td><b>Template</b></td><td>{{ document.template || "-" }}</td></tr>
                      <tr><td><b>Publisher</b></td><td>{{ document.publisher || "-" }}</td></tr>
                      <tr><td><b>Version</b></td><td>{{ document.version || "-" }}</td></tr>
                      <template v-for="(item, index) in document.details">
                        <tr :key="'file-' + index"><td><b>File</b></td><td><a v-if="item.file" :href="item.file" target="_blank">{{ fileName(item.file) }}</a><span v-else>-</span></td></tr>
                      </template>
                      <tr v-if="!document.details.length"><td><b>File</b></td><td>-</td></tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-6">
                  <table style="font-size: small" class="table table-hover table-sm table-borderless">
                    <tbody>
                      <tr><td><b>Department</b></td><td>{{ document.department || "-" }}</td></tr>
                      <tr><td><b>Privacy Level</b></td><td>{{ document.privacy_level || "-" }}</td></tr>
                      <tr><td><b>Partner</b></td><td>{{ document.partner || "-" }}</td></tr>
                      <tr><td><b>Permission Group</b></td><td>{{ document.permission_group || "-" }}</td></tr>
                      <tr><td><b>Status</b></td><td>{{ document.document_status || "-" }}</td></tr>
                      <tr><td><b>Created Date</b></td><td>{{ document.created_date || "-" }}</td></tr>
                      <template v-for="(item, index) in document.details">
                        <tr :key="'link-' + index"><td><b>Link</b></td><td><a v-if="item.link" :href="item.link" target="_blank">{{ item.link }}</a><span v-else>-</span></td></tr>
                      </template>
                      <tr v-if="!document.details.length"><td><b>Link</b></td><td>-</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="alert alert-danger">
          {{ errorMessage || "Document not found." }}
        </div>
        <br /><br />
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";
export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      document: {},
      isLoading: true,
      errorMessage: "",
    };
  },
  mounted() {
    this.loadDocument();
  },
  methods: {
    async loadDocument() {
      try {
        const { data } = await axios.get(
          "/document/view?id=" + this.$route.query.id,
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.document = data.data || {};
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Unable to load document.";
      } finally {
        this.isLoading = false;
      }
    },
    fileName(file) {
      return String(file || "")
        .split("/")
        .pop();
    },
  },
};
</script>
